import {
  ISportBackground,
  IUserSportBackgroundResponse,
} from '../../../../interfaces/user-sport-background.interface';
import { OTHER_SPORT } from '../../../../constants';

/**
 * Transform saved sport background data from API format to form format
 * Combines all careers into a single sport background with multiple teams
 */
export const transformSportBackgroundForEdit = (
  sportBg: IUserSportBackgroundResponse
): ISportBackground[] => {
  return [
    {
      id: sportBg.id,
      sportId: sportBg.sportId,
      sportName: sportBg.sport?.name || '',
      isOtherSport: sportBg.sportId === OTHER_SPORT.id,
      isIndividualSport: sportBg.isIndividual,
      isActiveSport: sportBg.activeCareer,
      startCareerDate: new Date(sportBg.startCareerDate),
      endCareerDate: sportBg.endCareerDate
        ? new Date(sportBg.endCareerDate)
        : (undefined as any),
      description: sportBg.description || '',
      teams: sportBg.careers.map((career) => ({
        id: career.id,
        isIndividualSport: sportBg.isIndividual,
        isActiveTeam: career.activeCareer,
        leagueId: career.idLeague || '',
        leagueName: career.leagueName || '',
        teamId: career.idTeam || '',
        teamName: career.teamName || '',
        startDateInTeam: career.startDate
          ? new Date(career.startDate)
          : (new Date() as any),
        endDateInTeam: career.endDate
          ? new Date(career.endDate)
          : (new Date() as any),
      })),
      fileData:
        sportBg.attachments?.map((a: any) => {
          // Create a fake File object for existing files to prevent null errors
          const blob = new Blob([''], { type: 'image/jpeg' });
          const fakeFile = new File([blob], a.fileName || 'existing-file.jpg', {
            type: 'image/jpeg',
          });
          // Add fileUrl and attachmentId as custom properties for existing files
          Object.defineProperty(fakeFile, 'fileUrl', {
            value: a.fileUrl,
            writable: false,
          });
          Object.defineProperty(fakeFile, 'attachmentId', {
            value: a.id,
            writable: false,
          });
          return {
            file: fakeFile as any,
            description: a.description,
            links: a.links || [],
            attachmentId: a.id, // Track attachment ID for updates/deletes
          };
        }) || [],
    },
  ];
};
